import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
export function ProductAdditionalEquipment({
  product,
}: {
  product: ProductItem;
}) {
  const { t } = useTranslation('products');
  return product.additional_equipment.length > 0 ? (
    <div className='px-5'>
      <div className='mb-4 border-b-[1px] py-5 font-secondary text-xl font-normal uppercase text-brand-500' />
      <p className='h2 mb-4'>
        {t('products:DETAIL_PAGE_ADDITIONAL_EQUIPMENT_TITLE')}
      </p>
      <ul className='mb-12'>
        {product.additional_equipment.map((item, index) => {
          return (
            <li key={index} className='pb-3 uppercase text-muted-500'>
              <strong>- {item.content}</strong>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
}
